//import AOS from 'aos';
import './types/hero';
import './types/clients-slider';
import './types/accordion';
import './types/accordion-simple';
import './types/latest-news';
import './types/quote-slider';
import './types/html';
import './types/platform-hero';
import './types/insights';
import './types/platform-tabs';
import './types/our-team';
import './types/features-list';

function removePTagsFromLinks() {
  const links = document.querySelectorAll('.wp-block-freeform.block-library-rich-text__tinymce a');

  if (links.length > 0) {
    links.forEach(link => {
      if (link.parentNode.nodeName === 'P') {
        const parent = link.parentNode;
        parent.parentNode.insertBefore(link, parent);
        parent.remove();
      }
    });
    return true;
  }
  return false;
}

document.addEventListener('DOMContentLoaded', function() {
  //AOS.init();

  const interval = setInterval(() => {
    if (removePTagsFromLinks()) {
      clearInterval(interval);
    }
  }, 1000); // Checks every 1 second
});

